export function makeNestedList(
    arr,
    id,
    parent_id,
    children_property = "children",
    priority_property = null
) {
    let map = {};
    let roots = [];

    arr.forEach((item) => {
        map[item[id]] = { ...item, [children_property]: [] };
    });

    arr.forEach((item) => {
        const parentId = item[parent_id];
        if (parentId && map[parentId]) {
            map[parentId][children_property].push(map[item[id]]);
        } else {
            roots.push(map[item[id]]);
        }
    });

    const sortTreeByPriority = (nodes) => {
        nodes.forEach((node) => {
            if (node[children_property].length > 0) {
                sortTreeByPriority(node[children_property]);
            }
        });

        if (priority_property) {
            nodes.sort((a, b) => {
                const priorityA = a[priority_property] ?? Infinity;
                const priorityB = b[priority_property] ?? Infinity;
                return priorityA - priorityB;
            });
        }
    };

    sortTreeByPriority(roots);

    const cleanEmptyChildren = (nodes) => {
        nodes.forEach((node) => {
            if (node[children_property].length === 0) {
                delete node[children_property];
            } else {
                cleanEmptyChildren(node[children_property]);
            }
        });
    };

    cleanEmptyChildren(roots);

    return roots;
};
